import React from 'react'
import { useStyles } from '../style'
import { Box, Typography } from '@mui/material'
import { ReactComponent as IllustrationSvg } from './illustration.svg'

const Expired = () => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.heading}>
        Sorry, the confirmation link is invalid or broken
      </Typography>
      <Box className={classes.containerContent}>
        <Typography className={classes.subtitle2}>
          Please follow the confirmation link from your email.
        </Typography>

        <Box className={classes.illustration}>
          <IllustrationSvg />
        </Box>
      </Box>
    </>
  )
}

export default Expired
